export const WS_HOME_PAGE_TYPES = {
  // Client -> Server
  GET_HOME_DATA: 'HOME_GET_DATA', // Consolidated request

  // Server -> Client
  RECENT_SERVERS_LIST: 'HOME_RECENT_SERVERS_LIST', // Specific list
  PROOFS_LIST: 'HOME_PROOFS_LIST',               // Specific list
  HOME_DATA_ERROR: 'HOME_DATA_ERROR',             // Specific error
  TYPE_RECENT_SERVERS_LIST: 'HOME_RECENT_SERVERS_LIST',
  TYPE_PROOFS_LIST: 'HOME_PROOFS_LIST'
};

export const WS_HOME_PAGE_TOPICS = {
  // App Endpoints
  APP_ENDPOINT_BASE: '/home',
  APP_GET_DATA: '/get-data', // Consolidated endpoint
  APP_GET_RECENT_SERVERS: '/get-recent-servers', // Paginated batch endpoint

  // User Queue Topics
  USER_QUEUE_BASE: '/user/queue/home',
  USER_RECENT_SERVERS: '/recent-servers', // Specific destination for this list
  USER_PROOFS: '/proofs',               // Specific destination for this list
  USER_ERROR: '/error',                // Specific destination for errors

  // Public Topics for Broadcasting
  PUBLIC_TOPIC_BASE: '/topic/home',
  PUBLIC_RECENT_SERVERS: '/recent-servers', // Public destination for real-time broadcasts
  PUBLIC_PROOFS: '/proofs'
};
export const getHomeAppEndpoint = (action) => `${WS_HOME_PAGE_TOPICS.APP_ENDPOINT_BASE}${action}`;
export const getHomeUserQueueTopic = (subTopic) => `${WS_HOME_PAGE_TOPICS.USER_QUEUE_BASE}${subTopic}`;
export const getHomePublicTopic = (subTopic) => `${WS_HOME_PAGE_TOPICS.PUBLIC_TOPIC_BASE}${subTopic}`;